// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-b10f58ca] {\n  width: 280px;\n}\n.card .text[data-v-b10f58ca] {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  color: #000000;\n}\n.card .text-small[data-v-b10f58ca] {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 13px;\n  color: #000000;\n}\n.card .text-left[data-v-b10f58ca] {\n  font-style: medium;\n  font-size: 13px;\n  color: #000000;\n}", ""]);
// Exports
module.exports = exports;
